import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentPage: 1,
  pages: {},
  totalCount: 0,
  loading: false,
  filter: {
    vendorName: undefined,
    manifestReference: undefined,
    status: undefined,
    receivedDateFrom: undefined,
    receivedDateTo: undefined,
  },
};

/* eslint no-param-reassign: ["error", { "ignorePropertyModificationsFor": ["state"] }] */
const stockManagementSlice = createSlice({
  name: 'stockManagement',
  initialState,
  reducers: {
    loadReceivings(state, action) {
      const { page, items, totalCount } = action.payload;
      state.pages[page] = items;
      state.totalCount = totalCount;
    },
    updateCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    updateFilter(state, action) {
      state.pages = {};
      state.totalCount = 0;
      state.filter = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
  },
});

export const stockManagementActions = stockManagementSlice.actions;
export default stockManagementSlice.reducer;
